import React, { useCallback } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  prependCrossClientLandingFinishedExecutions,
  setCrossClientLandingRunningExecutions,
  setCrossClientLandingTotalFinishedExecutions,
} from '../../../../store/crossClient/crossClientLanding'
import { useLazyGetAllCrossClientQueryExecutionsQuery, useLazyGetCrossClientQueryExecutionsQuery } from '../../../../store/crossClient/crossClient'
import { usePollingEffect } from '../../../../apps/professional-app/fa/common/hooks/usePollingEffect'
import { CROSS_EXECUTION_CLIENT_FINISHED_PHASES, CROSS_EXECUTION_CLIENT_RUNNING_PHASES } from '../../../../store/crossClient/utils'

const LIST_POLL_INTERVAL_MS = 15_000
const FINISHED_PAGE_SIZE = 5

export const CrossClientListPoller: React.FC = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const [triggerGetAllRunning] = useLazyGetAllCrossClientQueryExecutionsQuery()
  const [triggerGetFinished] = useLazyGetCrossClientQueryExecutionsQuery()

  const refreshLists = useCallback(async () => {
    const [running, finished] = await Promise.all([
      triggerGetAllRunning({
        accountId,
        phases: [...CROSS_EXECUTION_CLIENT_RUNNING_PHASES],
      }).unwrap(),
      triggerGetFinished({
        accountId,
        phases: [...CROSS_EXECUTION_CLIENT_FINISHED_PHASES],
        pageRequest: { page: 0, size: FINISHED_PAGE_SIZE },
      }).unwrap(),
    ])
    dispatch(setCrossClientLandingRunningExecutions(running.data))
    if (finished.data.length) {
      dispatch(prependCrossClientLandingFinishedExecutions(finished.data))
    }
    dispatch(setCrossClientLandingTotalFinishedExecutions(finished.page.totalElements))
  }, [dispatch, accountId, triggerGetAllRunning, triggerGetFinished])

  usePollingEffect(refreshLists, [], { interval: LIST_POLL_INTERVAL_MS, autoStart: true })

  return null
}
